import moment from 'moment'

export function format(date) {
  const DEFAULT_FORMAT = 'DD/MM/YYYY'
  return moment(date).format(DEFAULT_FORMAT)
}

export function time(date) {
  const DEFAULT_FORMAT = 'HH:mm'
  return moment(date).format(DEFAULT_FORMAT)
}

export function toDateTime(dateString, timeString) {
  const DEFAULT_FORMAT = 'DD/MM/YYYYHH:mm'
  return moment(dateString + timeString, DEFAULT_FORMAT).toDate()
}
